import React, { useState } from 'react';
import { useKeysDown } from 'shared/hooks/use-keys-down';

import { ContextMenuContext, Payload, Position } from './context';

export type ProviderProps = {
  children: React.ReactNode;
};

export const ContextMenuProvider: React.FC<ProviderProps> = ({ children }) => {
  const [state, setState] = useState<{
    position?: Position;
    payload?: Payload;
  }>({
    payload: undefined,
    position: undefined,
  });

  const open = (position?: Position, payload?: Payload) =>
    setState({ position, payload });

  const close = () => setState((prev) => ({ ...prev, position: undefined }));

  useKeysDown(['Escape'], close);

  return (
    <ContextMenuContext.Provider
      value={{
        position: state.position,
        payload: state.payload,
        open,
        close,
      }}
    >
      {children}
    </ContextMenuContext.Provider>
  );
};
